import { TRADE_TYPE } from '~/components/TradeDetail/types'
export interface ModalStatusProps {
  status: string
  statusText?: string
  tradeType?: TRADE_TYPE
}

export enum APPROVE_STATUS {
  APPROVING = 'approving',
  UN_APPROVING = 'unApproving',
  TIMEOUT = 'timeout',
  APPROVE_SUCCESS = 'approve_success',
  UNAPPROVE_SUCCESS = 'unApprove_success',
  REJECTED = 'rejected',
  UNAPPROVE_REJECTED = 'unApprove_rejected',
}
